<template lang="pug">
  footer(:class="[$style.footer, $style.foreignFooter, isRebrand ? $style.rebrandPadding : '']")
    div(
      :class="isRebrand? $style.rebrandLayout : ''"
      class="container font-semibold"
    )
      div(class="flex flex-col md:flex-row md:justify-between")
        div(:class="$style.trustPilot")
          client-only
            Trustpilot(
              theme="light"
              :width="Breakpoints_matchMedia('md') ? null : 168")
        div(:class="$style.contact")
          div(class="mb-ds-xs hidden md:block")
            PhoneNumber(
              :font-size="25"
              show-text)
          i18n-t(
            keypath="footer.availability"
            tag="p"
            class="mb-ds-md text-xs hidden md:block"
            scope="global")
            template(#br)
              br
          p(class="mb-ds-ms text-2xl hidden md:block")
            a(:href="emailHref")
              | {{email}}

        nav(:class="$style.links")
          a(:href="`${$config.public.v4Host}/es/sobre-nosotros`") {{ $t('footer.about_us') }}
          a(:href="`${v4Host}/categories`") {{ $t('footer.get_quotes') }}
          a(:href="`${v4Host}/preguntas`") {{ $t('footer.faq') }}
          a(:href="`${$config.public.v4Host}/es/transporta-para-anyvan`") {{ $t('footer.drive_with_anyvan') }}
          a(:href="`${$config.public.v4Host}/es/contactanos`") {{ $t('footer.contact_us') }}
        div(:class="$style.contact")
          img(
            class="inline-flex md:hidden fixed-size justify-center"
            src="~/assets/img/footer/PCI_DSS_Validated.webp"
            loading="lazy"
            width="82"
            height="45"
            alt="verify logo")
        client-only
          Trustpilot(
            class="hidden md:block w-[200px]"
            style="padding-left: 0;"
            theme="light"
            :width="Breakpoints_matchMedia('sm') ? null : 168")
      hr(:class="$style.hr")

      div(:class="$style.legal")
        .text-base.font-semibold {{ $t('footer.partners_title') }}
        div(:key="'partners'" class="flex flex-col gap-ds-ml sm:flex-row items-center")
          img(
            class="fixed-size self-center"
            src="~/assets/img/footer/partners-es.webp"
            loading="lazy"
            alt="partners logo")
        div(class="hidden text-right md:block lg:hidden")
          img(
            class="inline-block fixed-size"
            :class="$style.pciDssValidated"
            src="~/assets/img/footer/PCI_DSS_Validated.webp"
            loading="lazy"
            width="82"
            height="45"
            alt="verify logo")
        div(:class="$style.copy")
          nav
            a(:href="`/es/politica-de-privacidad`" target="_blank")
              | {{ $t('footer.privacy_policy') }}
            a(:href="`/es/terminos-y-condiciones`" target="_blank")
              | {{ $t('footer.terms_and_conditions') }}
            a(:href="`${v4Host}/mapa-web`")
              | {{ $t('footer.sitemap') }}
          div(:class="$style.copy")
            div(class="text-2xs text-center md:text-sm md:text-left")
              | {{ $t('footer.copyright', { currentYear }) }}
            div(class="hidden text-right md:block lg:hidden")
              img(
                class="inline-block fixed-size"
                :class="$style.pciDssValidated"
                src="~/assets/img/footer/PCI_DSS_Validated.webp"
                loading="lazy"
                width="82"
                height="45"
                alt="verify logo")

</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import FooterBase from "~/components/base/footerBase"
import { GET_USER } from "~/store/auth"
import { getV4Host } from "~/scripts/useful-functions"
import { LOCALE } from "~/constants/locale"

export default defineComponent({
  name: "TheFooterES",
  extends: FooterBase,
  computed: {
    ...mapGetters("auth", {
      user: GET_USER
    }),
    v4Host(): string {
      return getV4Host(this.$config.public.v4Host, LOCALE.ES)
    }
  }
})
</script>

<style lang="scss" module>
@import "~/assets/scss/footer.scss";
</style>
